<template>
	<div :class="{ center: alignment === 'center' }">
		<svg class="loading-icon">
			<circle
				cx="50%"
				cy="50%"
				r="25"
				stroke="#006199"
				stroke-width="2"
				fill="none"
			></circle>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'LoadingIcon',
	props: {
		alignment: String,
	},
};
</script>

<style lang="scss" scoped>
.center {
	@include rem('padding', 25px);
	display: flex;
	justify-content: center;
	align-items: center;
}

.loading-icon {
	stroke-dasharray: 155;
	stroke-dashoffset: 0;
	animation: draw-circle 2s ease-in infinite, spin 2s linear infinite;
	width: 60px;
	height: 60px;
}

@keyframes draw-circle {
	0% {
		stroke-dashoffset: 310;
	}

	50% {
		stroke-dashoffset: 155;
	}

	100% {
		stroke-dashoffset: 0;
	}
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}
</style>
